// extracted by mini-css-extract-plugin
export var loadingSpinner = "_62-1";
export var standaloneTable = "_62-0";